<p-datePicker
          #dp
          class="w-100"
          [(ngModel)]="rangeDates"
          selectionMode="range"
          rangeSeparator="-"
          [numberOfMonths]="isMobile ? 1 : 2"
          [firstDayOfWeek]="1"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [readonlyInput]="true"
          [showIcon]="true"
          [showOtherMonths]="false"
          [dateFormat]="settings.get('searchMask.dateFormat') ?? 'dd.mm.yy'"
          inputId="templatedisplay"
          [iconDisplay]="'button'"
          [keepInvalid]="true"
          (onShow)="handleOnShow()"
          (onClickOutside)="handleClickOutside()"
          (onSelect)="handleDatepickerSelect($event)"
          (onMonthChange)="handleMonthChange($event)"
          [attr.data-testid]="'datepicker-input'"
        >

          <ng-template #triggericon>
              <span class="material-symbols-outlined" [attr.data-testid]="'datepicker-select'">date_range</span>
          </ng-template>
          <ng-template #date let-date >
            <div (mouseover)="setHoveredDate(date)" [class.is-selected-arrival]="isSelectedArrival(date)">
              <span [class.selected-range-on-hover]="isInFuture(date)" >
                {{date.day}}
                @if (showAvailability && (hotelCode && hotelCode != 'ALL')) {
                  <div class="dp-availability-ball-container">
                    <span class="dp-availability-ball" [class]="getDatepickerAvailabilityBall(date)" [attr.data-testid]="'availability-ball'"></span>
                  </div>
                }
                @if (showPrices && (hotelCode && hotelCode != 'ALL')) {
                  <div class="dp-min-price-container">
                    <span class="dp-min-price">{{getMinPrice(date)}}</span>
                  </div>
                }
              </span>
            </div>
          </ng-template>



          <ng-template #footer>
            @if (showAvailability) {
              @if (hotelCode == 'ALL') {
                <div class="dp-legend-container">
                  <div class="dp-legend">
                    {{"sm.LegendSelectAHotel"|translate}}
                  </div>

                </div>
              }
              @else {
                <div class="dp-legend-container">
                  <div class="dp-legend">
                    <span class="dp-availability-ball available"></span> {{"sm.LegendRoomsAvailable"|translate}}
                  </div>
                  <div class="dp-legend">
                    <span class="dp-availability-ball fewleft"></span> {{"sm.LegendFewLeft"|translate}}
                  </div>
                  <div class="dp-legend">
                    <span class="dp-availability-ball soldout"></span> {{"sm.LegendNoRoomsAvailable"|translate}}
                  </div>
                  <div class="dp-legend">
                    <span class="dp-availability-ball nodata"></span> {{"sm.LegendNoData"|translate}}
                  </div>
                </div>
              }

            }
            <div class="footerAdvertisementTextContainer">
              @for (notification of notificationsForMonth; track $index) {
                @if (notification.title.length > 0 && notification.description.length > 0) {
                    <p-message class="notification-container" [severity]="mapNotificationColor(notification.color)" [closable]="notification.closable">
                        <p><b>{{notification.title}}</b></p>
                        <div [innerHtml]="notification.description"></div>
                    </p-message>
                }
              }
              <!-- PIM2 DatePicker notifications; includeLegacy=false avoids duplicating the legacy month-aware notifications rendered above -->
              <app-pim-notification phase="DatePicker" [includeLegacy]="false"></app-pim-notification>
            </div>



          </ng-template>

          <!-- p-datepicker-next and ..prev -classes are to fix the z-index bouncing bug when changing the month  -->

          <ng-template #nexticon>
            <div class="p-datepicker-next d-flex">
              <span class="material-symbols-outlined" [attr.data-testid]="'datepicker-next-button'">
                keyboard_arrow_right
              </span>
            </div>
          </ng-template>
          <ng-template #previousicon>
            <div class="p-datepicker-prev d-flex" disabled="true">
              <span class="material-symbols-outlined" [attr.data-testid]="'datepicker-previous-button'">
                keyboard_arrow_left
              </span>
            </div>
          </ng-template>

</p-datePicker>
